<!--
 * @Description: 补发记录
 * @Author: gao shuai
 * @Date: 2020-08-27 15:47:35
 * @LastEditTime: 2020-09-01 16:09:13
 * @LastEditors: gao shuai
-->

<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>订单管理</el-breadcrumb-item>
        <el-breadcrumb-item>补发记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <ul class="clearfix">
        <li>
          <span class='tit'>开始时间：</span>
          <span class="txtbox">
            <!-- <el-date-picker style="width:338px;" v-model="time" size="small" type="datetimerange" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker> -->
            <el-date-picker style="width:190px;" v-model="time1" size="small" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
            </el-date-picker> <span style="font-size:14px;">至 </span>
            <el-date-picker style="width:190px;" v-model="time2" size="small" default-time="23:59:59" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
            </el-date-picker>
          </span>
        </li>
        <li>
          <span class='tit'>商户ID：</span>
          <span class="txtbox">
            <el-input style="width:120px;" type="number" size="small" v-model="merchantId" @input="chantid=intNumber(chantid)" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>商户账号：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" v-model="merchantAccount" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>游戏账号：</span>
          <span class="txtbox">
            <el-input size="small" style="width:140px;" v-model="gameaccount" placeholder="请输入内容"></el-input>
          </span>
          <span class="mgl10">
            <el-button size="small" type="primary" @click="()=>{pageIndex=1;getlist()}">查询</el-button>
          </span>
        </li>
      </ul>
    </div>
    <div class="contBox mgt10 clearfix">
      <div class="tabBox">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="全部" name="2"></el-tab-pane>
          <el-tab-pane label="手动充值" name="1"></el-tab-pane>
          <el-tab-pane label="整区补发" name="0"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="gs_tablebox">
        <el-table ref="moduleTable" size="mini" :data="tableData" border style="width: 100%" stripe>
          <el-table-column prop="merchantId" label="商户ID" width="90">
          </el-table-column>
          <el-table-column prop="merchantAccount" label="商户帐号">
          </el-table-column>
          <el-table-column prop="date" label="补发时间" width="100">
            <template slot-scope="scope">
              <p style="height:20px;">{{scope.row.reissueDate.split(' ')[0]}}</p>
              <p style="color:#999;height:20px;">{{scope.row.reissueDate.split(' ')[1]}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="serialNumber" label="业务流水" width="220">
          </el-table-column>
          <el-table-column prop="partitionsName" label="所属分区" width="250">
          </el-table-column>
          <el-table-column prop="playerAccount" label="玩家账号">
          </el-table-column>
          <el-table-column prop="productName" label="付款方式">
          </el-table-column>
          <el-table-column label="补发金额">
            <template slot-scope="scope">
              <span style="color:#00b066;">{{scope.row.amount.toFixed(2)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="补发方式">
            <template slot-scope="scope">
              <span style="color:#00b066;">{{scope.row.type?'手动充值':'整区补发'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="补发IP">
            <template slot-scope="scope">
              <span style="color:#00b066;">{{scope.row.clientIp}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="gs_pagenumber">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :page-sizes="[10, 20, 30, 40]" :current-page="pageIndex" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time1: this.getCerentTime(true), // 开始时间
      time2: this.getCerentTime(false), // 开始时间
      activeName: '2', // tab切换卡
      merchantId: '', // 商户ID
      merchantAccount: '', // 商户帐号
      gameaccount: '', // 游戏账号
      gameDivisionpage: '', // 游戏分区
      gameDivisiondrow: [], // 游戏分区下拉
      gameDivision: '', // 游戏分区
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      tableData: []
    };
  },
  methods: {
    // tab的切换
    handleClick() {
      this.pageIndex = 1;
      this.pageSize = 10;
      this.total = 0;
      this.tableData = [];
      this.getlist();
    },
    // 获取列表
    getlist() {
      this.$api.order
        .ressueList({
          Type: this.activeName === '2' ? '' : this.activeName,
          StartReissueDate: this.time1 ? this.time1 : null,
          EndReissueDate: this.time2 ? this.time2 : null,
          PlayerAccount: this.gameaccount,
          MerchantId: this.merchantId === '' ? 0 : this.merchantId,
          MerchantAccount: this.merchantAccount,
          PartitionId: this.gameDivisionpage === '' ? 0 : this.gameDivisionpage,
          PartitionName: this.gameDivision,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 游戏下拉
    // gameDrow() {
    //   this.$api.reorder
    //     .gamelist()
    //     .then((data) => {
    //       if (data.status === 200) {
    //         this.gameDivisiondrow = data.data;
    //       } else if (data.status === 204) {
    //         this.gameDivisiondrow = [];
    //       }
    //     })
    //     .catch((err) => {
    //       this.$messageError(err.message);
    //     });
    // },
    // 今天日期
    // gsToday() {
    //   this.time = [this.getCerentTime(true), this.getCerentTime(false)];
    //   this.pageIndex = 1;
    //   this.getlist();
    // },
    // 上一天日期
    // yesterday() {
    //   this.time = this.getYesterday(
    //     this.time ? this.time[0].split(' ')[0] : null
    //   );
    //   this.pageIndex = 1;
    //   this.getlist();
    // },
    // 下一天日期
    // Tomorrow() {
    //   this.time = this.getTomorrow(
    //     this.time ? this.time[0].split(' ')[0] : null
    //   );
    //   this.pageIndex = 1;
    //   this.getlist();
    // },
    // 清除记录
    // clearOrder() {
    //   this.$api.reorder
    //     .clearOrder({
    //       startTime: this.time ? this.time[0] : null,
    //       endTime: this.time ? this.time[1] : null
    //     })
    //     .then((data) => {
    //       this.$messageSuccess('清除成功！');
    //       this.getlist();
    //     })
    //     .catch((err) => {
    //       this.$messageError(err.message);
    //     });
    // },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
    }
  },
  created() {
    this.getlist();
    // this.gameDrow();
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;
  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
}
.gs_slectbox {
  display: inline-block;
  border: 1px solid #ddd;
  padding: 2px 8px;
  border-radius: 4px;
  position: relative;
  // z-index: 9999;
  &:hover {
    .meaulist {
      display: block;
      z-index: 999;
    }
  }
  .tit {
    display: block;
  }
  .meaulist {
    position: absolute;
    background: red;
    display: none;
    top: 20px;
    left: 10px;
  }
}
.contBox {
  // padding-top: 10px;
  // background: #fff;
  .tabBox {
    float: left;
    background: #fff;
    // padding-left: 15px;
    &::v-deep .el-tabs__header {
      margin-bottom: 0;
      border-bottom: none;
      .el-tabs__item {
        border-bottom: none;
        &.is-active {
          background: #409eff;
          color: #fff;
        }
      }
    }
  }
}
</style>
